import * as React from "react";
const SvgEth = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.4455 8.15L7.72432 11.05L3 8.15L7.72432 0L12.4455 8.15ZM7.72432 11.9812L3 9.08125L7.72432 16L12.4486 9.08125L7.72432 11.9812Z" }));
export default SvgEth;
